export default __webpack_public_path__ + "static/media/branding_s.869cdc14.jpg";